//const apiBaseUrl = "http://127.0.0.1:8000/"
const apiBaseUrl = "https://gde1d548g6.execute-api.eu-north-1.amazonaws.com/api/"
const chatBaseUrl = "https://chat.meet.rlab.systems/"

export {apiBaseUrl, chatBaseUrl}
